import { agricolaReportsSettings } from 'src/app/routes/agricola/settings/settings';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import * as _ from 'lodash';
import { UserSettingsService } from 'src/app/Services/agricola/settings.service';
import { IncidencesService } from 'src/app/Services/agronodo/incidences.service';
import { ReportsGlobalService } from 'src/app/Services/agricola/reports.service';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { FieldSectorService } from '../../fields/services/sectors.service';
import { FieldService } from '../../fields/services/field.service';
import { ReportsService } from '../../fields/services/reports.service';
import { Subscription } from 'rxjs';
import { sector } from '../../fields/interfaces/sectors.interface';
import { reportNormal } from 'src/app/Services/public/icons';

@Component({
  selector: 'app-individual-report-form',
  templateUrl: './individual-report-form.component.html',
  styleUrls: ['./individual-report-form.component.scss'],
})
export class IndividualReportFormComponent implements OnInit {
  incidencesAList: any = [];
  incidencesTList: any = [];

  selectedDate: NgbDateStruct;
  selectedTime: NgbTimeStruct;
  sector: sector | null;
  title: string = '';
  observation: string = '';
  iconReport = reportNormal;

  typeReport: any = 2;

  imageError!: any;

  multimediaType = 1;

  video: any;
  videoToUpload: any;
  rawVideoUrl: string;

  audio: any;
  audioToUpload: any;
  rawAudioUrl: string;

  selectedIncidence: number = 0;
  incidencesToUpload: any = [];
  incidenceArray: any = [];
  incidenceArrayObject = {
    type: 'T',
    name: '',
    amount: 0,
    fruit: 1,
    plant: 1,
    soil: 1,
    description: '',
    datetime: null,
  };

  base64Images: any = [];
  imagesFiles: any = [];
  imagesFile: any;

  filePhoto: any = '';

  agricolaReportsSettings = agricolaReportsSettings;
  requiredFields: any;

  loading: Boolean = false;

  position: { lat: number; lng: number } | null;
  selectedPosition: boolean = false;

  sectorSuscription: Subscription | undefined;
  positionSuscription: Subscription | undefined;

  constructor(
    public location: Location,
    public route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    public globalFunction: GlobalFunction,
    public reportsGlobalService: ReportsGlobalService,
    public settingsService: UserSettingsService,
    public fieldsService: FieldService,
    public fieldSectorService: FieldSectorService,
    public incidencesSerivce: IncidencesService,
    public sectorService: FieldSectorService,
    public reportsService: ReportsService,
    public router: Router
  ) {}

  ngOnDestroy() {
    if (this.sectorSuscription) {
      this.sectorSuscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.sectorSuscription =
      this.reportsService.createReportObservable$.subscribe((sector) => {
        this.sector = sector;
      });

    this.positionSuscription =
      this.reportsService.positionReportObservable$.subscribe((position) => {
        this.position = position;
      });

    const now = new Date();

    this.selectedDate = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };

    this.selectedTime = {
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: 0,
    };
    this.selectedPosition = false;
    this.getIncidenceList();
    this.getSettings();
  }

  getSettings() {
    this.settingsService.getSettings().subscribe((res) => {
      if (res) {
        console.log(res);
        this.agricolaReportsSettings = res;
        this.obtainRequiredFields();
      }
    });
  }

  getIncidenceList() {
    this.incidencesSerivce.getAIncidences('').subscribe((res) => {
      this.incidencesAList = res;
    });
    this.incidencesSerivce.getTIncidences('').subscribe((res) => {
      this.incidencesTList = res;
    });
  }

  addIncidence() {
    const now = new Date();
    const currentDate = now.toISOString();

    this.incidenceArrayObject = {
      type: 'T',
      name: '',
      amount: 0,
      fruit: 1,
      plant: 1,
      soil: 1,
      description: '',
      datetime: currentDate,
    };
    this.incidenceArray.push(this.incidenceArrayObject);
    this.incidencesToUpload.push(this.incidenceArrayObject);

    this.selectedIncidence = this.incidenceArray.length - 1;
  }

  blobToFile(blob: Blob, fileName: string): File {
    const file = new File([blob], fileName);
    return file;
  }

  getImageCropper(event) {
    this.filePhoto = event;
  }

  addImageToList() {
    this.imagesFiles.push(this.filePhoto);
    const base64WithoutHeader = this.filePhoto.split(',')[1];

    const obj = {
      image: this.filePhoto,
    };

    this.base64Images.push(obj);

    this.filePhoto = null;
  }

  fileToBase64(base64String: string): File {
    const matches = base64String.match(/^data:(.+);base64,/);
    const mimeType = matches ? matches[1] : 'application/octet-stream';
    const base64Data = base64String.split(',')[1] || base64String;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: mimeType });

    const extension = mimeType.split('/')[1] || 'bin';
    const filename = `archivo.${extension}`;

    return new File([blob], filename, { type: mimeType });
  }

  removeMultimedia(type: 'audio' | 'video', multimedia: string) {
    let url: string;

    if (type === 'video') {
      url = this.rawVideoUrl ?? multimedia.toString();
    } else {
      url = this.rawAudioUrl ?? multimedia.toString();
    }

    if (url.startsWith('blob:')) {
      // Recurso local (no está en el servidor)
      if (type === 'video') {
        this.video = null;
        URL.revokeObjectURL(url); // Libera el recurso
        this.rawVideoUrl = null;
      } else {
        this.audio = null;
        URL.revokeObjectURL(url);
        this.rawAudioUrl = null;
      }
    }
  }

  removeImage(image, index) {
    this.imagesFiles.splice(index, 1);
    this.base64Images.splice(index, 1);
  }

  changeIncidence(i) {
    this.selectedIncidence = i;
  }

  removeIncidence() {
    console.log(this.selectedIncidence);

    this.incidenceArray.splice(this.selectedIncidence, 1);
    this.incidencesToUpload.splice(this.selectedIncidence, 1);

    this.selectedIncidence = this.incidenceArray.length - 1;
    this.incidenceArrayObject = this.incidenceArray[this.selectedIncidence];
  }

  typeAgriculture(type: string) {
    if (type === 'T') {
      return 'assets/img/typeagro/traditional.png';
    }
    return 'assets/img/typeagro/greenhouse.png';
  }

  fileReady(event: any) {
    const files = event.target.files;
    if (files && files[0]) {
      const objectUrl = URL.createObjectURL(files[0]);

      if (this.multimediaType === 1) {
        this.videoToUpload = files[0];
        this.rawVideoUrl = objectUrl;
        this.video = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      } else {
        this.audioToUpload = files[0];
        this.rawAudioUrl = objectUrl;
        this.audio = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      }
    }
  }

  getNormalDate(date, time) {
    const data = `${date.year}-${date.month}-${date.day}`;
    return data;
  }

  convertDateTimeString(date) {
    const dateParts = date.split('T')[0].split('-');
    const timeParts = date.split('T')[1].split('.')[0].split(':');
    const timeZoneOffset = date.split('-')[1];

    this.selectedDate = {
      year: +dateParts[0],
      month: +dateParts[1],
      day: +dateParts[2],
    };

    this.selectedTime = {
      hour: +timeParts[0],
      minute: +timeParts[1],
      second: +timeParts[2],
    };
  }

  createCommonIncidenceObject(incidence) {
    return {
      sector: this.sector.id,
      type: incidence.type,
      description: incidence.description,
      datetime: incidence.datetime,
    };
  }

  createAgriculturalIncidenceObject(incidence) {
    return {
      ...this.createCommonIncidenceObject(incidence),
      agricultural_incidence: {
        name: {
          name: incidence.name,
        },
        amount: incidence.amount,
        ground: incidence.soil,
        plant: incidence.plant,
        fruit: incidence.fruit,
      },
    };
  }

  createTechnicalIncidenceObject(incidence) {
    return {
      ...this.createCommonIncidenceObject(incidence),
      technical_incidence: {
        name: {
          name: incidence.name,
        },
      },
    };
  }

  creatingIncidences() {
    const temporalIncidences = [];

    this.incidencesToUpload.forEach((incidence) => {
      let obj;
      if (incidence.type === 'A') {
        obj = this.createAgriculturalIncidenceObject(incidence);
      } else {
        obj = this.createTechnicalIncidenceObject(incidence);
      }

      temporalIncidences.push(obj);
    });
    return temporalIncidences;
  }

  getDateTime() {
    const { year, month, day } = this.selectedDate;
    const { hour, minute } = this.selectedTime;
    const selectedDate = new Date(year, month - 1, day, hour, minute, 0);

    return selectedDate.toISOString();
  }

  submitReport() {
    const temporalIncidences = this.creatingIncidences();

    const obj = {
      title: this.title,
      observation: this.observation,
      area: this.reportsService.areaReport,
      field: this.sector.father_field,
      sector: this.sector.id,
      type: 4,
      datetime: this.getDateTime(),
      lat: this.position.lat,
      lng: this.position.lng,
      incidences: temporalIncidences,
    };

    const validated = this.validateRequiredFields(temporalIncidences);

    if (validated) {
      this.loading = true;

      this.reportsGlobalService.postIndividualReport(obj).subscribe({
        next: (res) => {
          this.uploadMultimedia(res);
          this.loading = false;
          this.reportsService.setSectorCreateReport(null);
          this.reportsService.setViewPositionReport(null);
          this.globalFunction.animation(
            'success',
            '¡Enhorabuena!',
            'Reporte creado correctamente'
          );
          this.selectedPosition = false;

          this.router.navigateByUrl(
            `/agricola/lotes/${this.sector.father_field}/sectores/${this.sector.id}/inicio/reportes`
          );
        },
        error: (err) => {
          this.loading = false;
        },
      });
    }
  }

  uploadMultimedia(res) {
    this.imagesFiles.forEach((image) => {
      let formData = new FormData();
      formData.append('image', this.fileToBase64(image));

      this.reportsGlobalService
        .imageUpload(res.id, formData)
        .subscribe((res) => {});
    });

    if (this.videoToUpload) {
      let formData = new FormData();
      formData.append(
        'video',
        this.blobToFile(this.videoToUpload, 'video.mp4')
      );
      this.reportsGlobalService
        .videoUpload(res.id, formData)
        .subscribe((res) => {});
    }

    if (this.audioToUpload) {
      let formData = new FormData();
      formData.append(
        'audio',
        this.blobToFile(this.audioToUpload, 'audio.mp3')
      );
      this.reportsGlobalService
        .audioUpload(res.id, formData)
        .subscribe((res) => {});
    }
  }

  obtainRequiredFields() {
    this.requiredFields = Object.keys(this.agricolaReportsSettings).filter(
      (key) => this.agricolaReportsSettings[key] && key != 'id'
    );
  }

  _mapper = {
    title_required: 'title',
    observation_required: 'observation',
    area_required: 'area',
    video_required: 'video',
    image_required: 'imagesFile',
    audio_required: 'audio',
    incidence_description_required: 'description',
  };

  validateRequiredFields(temporalIncidences) {
    let flag = true;

    this.requiredFields.forEach((key) => {
      if (this._mapper.hasOwnProperty(key)) {
        const value = this._mapper[key];

        if (key.includes('incidence')) {
          if (temporalIncidences.length == 0) {
            return;
          } else {
            console.log('temporalIncidences', temporalIncidences);

            temporalIncidences.forEach((element) => {
              if (element.cantEdit && element.cantEdit == true) return;

              if (!element[value]) {
                flag = false;
                this.globalFunction.animation(
                  'error',
                  `El campo: ${key} es requerido en alguna de tus incidencias`,
                  'Campo requerido'
                );
              }
            });
          }
        } else {
          if (key.includes('image_required')) {
            if (this.imagesFiles.length == 0) {
              flag = false;
              this.globalFunction.animation(
                'error',
                `Almenos una imagen es requerida`,
                'Campo requerido'
              );
            }
          } else {
            if (!this[value]) {
              flag = false;
              this.globalFunction.animation(
                'error',
                `El campo: ${key} es requerido`,
                'Campo requerido'
              );
            }
          }
        }
      }
    });

    return flag;
  }

  isDateInRange(): boolean {
    const { start_date, finish_date } = this.sector.current_cycle;
    const date = this.getDateTime();

    const d = new Date(date);
    const s = new Date(start_date);
    const e = new Date(finish_date);

    return d >= s && d <= e;
  }
  validateForm(): boolean {
    if (!this.position || !this.position.lat || !this.position.lng) {
      if (
        !this.sector ||
        !this.isDateInRange() ||
        this.observation ||
        this.reportsService.areaReport <= 0
      ) {
        return true;
      }
    }
    return false;
  }
  clickViewReport() {
    this.selectedPosition = !this.selectedPosition;
    this.reportsService.setViewPositionReport(this.selectedPosition);
  }
}
